import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { TransactionLinkType } from "@bitwarden/web-vault/app/models/types/transaction.types";
import {
  linkTypeIcon,
  linkTypeLabel,
} from "@bitwarden/web-vault/app/models/types/transaction-link-display.utils";

/**
 * The transfer/conversion link badge, shared verbatim by the transaction-desc-renderer
 * grid cell, the link-transaction-picker list and the transaction-details Link row so the
 * pill markup can't drift between them (the duplication this component replaces had already
 * done so). The host element is
 * the pill itself - callers add placement-only classes (e.g. `tw-mr-1.5`) at the call site.
 * Icon/label come from {@link linkTypeIcon}/{@link linkTypeLabel}, the single source of
 * truth for how a link type renders.
 */
@Component({
  selector: "app-link-type-badge",
  standalone: true,
  templateUrl: "./link-type-badge.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      "tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1 tw-rounded-full tw-bg-dt-surface-sunken tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-medium tw-leading-none tw-text-dt-text-secondary",
    "[attr.data-testid]": "'transaction-link-badge-' + type()",
  },
})
export class LinkTypeBadgeComponent {
  readonly type = input.required<TransactionLinkType>();

  protected readonly icon = computed(() => linkTypeIcon(this.type()));
  protected readonly label = computed(() => linkTypeLabel(this.type()));
}
